import BaseDialog from '../../common/BaseDialog';
import { FormattedMessage } from 'react-intl';
import { DialogButton } from '@rmwc/dialog';
import React from 'react';
import { CustomerProductSelectionTable } from '../CustomerProductSelectionTable';

const CustomerProductSelectDialog = ({ isOpen, onClose, item, selectedDatePeriods, onDatePeriodSelect }) => {
    const renderDialogActions = () => {
        return (
            <div>
                <DialogButton action="accept" className="mdc-button mdc-button--unelevated" isDefaultAction>
                    <FormattedMessage id="General.Select" />
                </DialogButton>
            </div>
        )
    }

    return (
        <BaseDialog isOpen={isOpen} onClose={onClose} dialogActions={renderDialogActions()} className="mdc-dialog--wide">
          <CustomerProductSelectionTable
              selectedDatePeriods={selectedDatePeriods}
              onDatePeriodSelect={onDatePeriodSelect}
              primaryProductId={item.id}
              primaryProductType={item.type}
              primaryProductMargin={item.marginal}
              connectedProductId={item.connectedProduct.id}
              connectedProductMargin={item.connectedProduct.marginal}
          />
        </BaseDialog>
    );
};

export default CustomerProductSelectDialog;